export default {
  title: 'Offerte esclusive',
  header: {
    back: 'Indietro',
    title: 'Premi',
  },
  info: {
    title: 'Hai {{points}} punti.',
    description:
      'Spendi {{amount}} per ottenere 5 punti! Aggiungi articoli al carrello gratuitamente con i tuoi punti accumulati.',
  },
  rewards: {
    data: [
      {
        title: 'Accumula punti per ogni ordine',
        description: 'Ogni {{amount}} che spendi aggiunge 5 punti al tuo account.',
      },
      {
        title: 'Accumula punti per ogni ordine',
        description:
          'Riscatta i tuoi punti per omaggi gratuiti! Inizia a guadagnare premi da 350 punti, equivalenti a una spesa di {{amount}}.',
      },
      {
        title: 'Accumula punti per ogni ordine',
        description:
          "Scopri offerte esclusive, promozioni e sconti. Consulta le promozioni riservate ai membri nell'app.",
      },
    ],
  },
};
